module.exports = __webpack_public_path__ + "img/ex_pid_person_image.b32f4e32.png";